export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404493f832dde81b00d721e608b756c1f74e85b535&name=revalidateCommunity!'